/**
 * Rejestr faktur zaksięgowanych w bieżącej procedurze księgowania — używany
 * przez kolejkę „Następna faktura do księgowania" (MenuCell rejestru KSeF), by
 * pomijać już zaksięgowane pozycje. Stan sesyjny (moduł) — czyszczony przy
 * odświeżeniu strony. Klucz = KsefNumber (jeśli jest) lub Id wiersza.
 */
const bookedKeys = new Set<string>();

export const bookingKeyOf = (
  row: { KsefNumber?: string; Id?: string } | null | undefined,
): string => (row?.KsefNumber || row?.Id || "").toString();

export const markInvoiceBooked = (key: string): void => {
  if (key) bookedKeys.add(key);
};

export const isInvoiceBooked = (key: string): boolean =>
  !!key && bookedKeys.has(key);
